var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',[_c('div',{staticClass:"container",attrs:{"id":"zoned-rate-editor"}},[_c('div',{staticClass:"box"},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',[_c('EditRates',{attrs:{"rate-plan-id":_vm.ratePlanId}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }